import React from 'react';
import { Navigate } from 'react-router-dom';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useAuth } from '../context-providers/auth-provider';
import ROUTES from './routes';
import { useSettings } from '../context-providers/settings-provider';

export default function SetUpRoute(props: any) {
    const { isAuthenticated, isVerified, initialized } = useAuth();
    const { publicSettings } = useSettings();

    if (!initialized || !publicSettings) {
        return (<Backdrop open><CircularProgress color="inherit" /></Backdrop>);
    }

    if (!isAuthenticated()) {
        return <Navigate to={ROUTES.LOGIN} replace />;
    }

    if (!isVerified()) {
        return <Navigate to={ROUTES.CONFIRM} replace />;
    }

    if (publicSettings.username) {
        return <Navigate to={ROUTES.HOME} replace />;
    }

    return <>{props.children}</>;
}
